import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import useServiceMetricsSince from './useServiceMetricsSince';
import Tooltip from '@material-ui/core/Tooltip';
import { metricNames } from '@linearb/linjs-common';
import { getColor } from 'common/constants/_colors';
import { LineSkeleton as LineLoader } from 'components/base/Skeletons';

const StyledServiceMetricsChart = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DEFAULTS = {
  METRIC_NAME: metricNames.CYCLE_TIME,
  SINCE_LAST_X_DAYS: 30,
  POINTS_LENGTH: 30
};

const ServiceMetricsChart = ({
  service,
  metricName = DEFAULTS.METRIC_NAME,
  sinceLastXDays = DEFAULTS.SINCE_LAST_X_DAYS,
  pointsLength = DEFAULTS.POINTS_LENGTH
}) => {
  const {
    loading,
    isPending,
    data: metricsData = []
  } = useServiceMetricsSince(service, {
    sinceLastXDays,
    pointsLength,
    requestedMetrics: [metricName]
  });
  const isEmptyData = _.every(metricsData, metric => !metric[metricName]);

  const TooltipTitle = isEmptyData
    ? 'No activity in the past 30 days'
    : 'Service activity in the past 30 days';

  return (
    <Tooltip
      title={TooltipTitle}
      placement='top'
      disableHoverListener={isPending}
    >
      <StyledServiceMetricsChart>
        {loading ? (
          <LineLoader size={90} />
        ) : isPending ? (
          <>
            New service <br /> Pending Activity
          </>
        ) : (
          <ResponsiveContainer width='100%' height='100%'>
            <LineChart width='100%' height='100%' data={metricsData}>
              <Line
                type='monotone'
                stroke={getColor('chambray')}
                strokeWidth={2}
                dot={false}
                dataKey={metric => metric[metricName] || 0}
                {...(isEmptyData ? { strokeDasharray: '3 4' } : {})}
              />
            </LineChart>
          </ResponsiveContainer>
        )}
      </StyledServiceMetricsChart>
    </Tooltip>
  );
};

export default ServiceMetricsChart;
